// Drawer styles configuration for ProposalDetailPage
export const drawerStylesConfig = {
  borderRadius: '16px',
  backgroundColor: 'var(--color-assist-4)',
  transparentMask: 'transparent',
  fullWidth: '100%',
  noMargin: '0',
  noBorder: 0,
};

export const createDrawerStyles = (config = drawerStylesConfig) => ({
  body: {
    borderTopLeftRadius: config.borderRadius,
    borderTopRightRadius: config.borderRadius,
    backgroundColor: config.backgroundColor,
  },
  wrapper: {
    borderTopLeftRadius: config.borderRadius,
    borderTopRightRadius: config.borderRadius,
    width: config.fullWidth,
    maxWidth: 'none',
    margin: config.noMargin,
  },
  content: {
    borderTopLeftRadius: config.borderRadius,
    borderTopRightRadius: config.borderRadius,
  },
  header: {
    borderTopLeftRadius: config.borderRadius,
    borderTopRightRadius: config.borderRadius,
    backgroundColor: config.backgroundColor,
    borderBottom: config.noBorder,
    boxShadow: 'none',
  },
  mask: {
    backgroundColor: config.transparentMask,
  },
});

// Default export with pre-configured styles
export default createDrawerStyles();
